
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/reisen-buchen",
      function () {
        return require("private-next-pages/[region]/[resort]/reisen-buchen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/reisen-buchen"])
      });
    }
  